import * as React from 'react';

const SvgFilter = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.4 2.15c.295 0 .583.24.583.65v1.533c0 .057-.025.199-.109.385-.08.18-.184.331-.27.418l-.014.014-2.534 2.667a.77.77 0 0 0-.042.048 3.402 3.402 0 0 0-.477.84c-.12.302-.22.667-.22 1.028v3.534c0 .434-.514.741-.919.498l-.926-.596a.754.754 0 0 0-.02-.012c.003.001-.016-.01-.049-.048a.794.794 0 0 1-.096-.146.735.735 0 0 1-.09-.296V9.8a2.97 2.97 0 0 0-.243-1.134c-.147-.347-.372-.704-.684-.968L3.45 5.19a1.75 1.75 0 0 1-.292-.459 1.393 1.393 0 0 1-.141-.53V2.732c0-.319.264-.583.583-.583h8.8Zm2.083.65c0-1.19-.912-2.15-2.083-2.15H3.6a2.087 2.087 0 0 0-2.083 2.083V4.2c0 .408.123.817.275 1.152a3.177 3.177 0 0 0 .645.943L5.303 8.83a1.112 1.112 0 0 1 .29.423c.083.196.124.397.124.548v2.867c0 .349.11.701.26.988.144.278.373.585.692.781l.926.595.012.008c1.328.817 3.21-.075 3.21-1.772V9.733c0-.105.034-.273.113-.471a1.98 1.98 0 0 1 .239-.438L13.67 6.19c.243-.245.437-.558.572-.858.133-.297.24-.655.24-.999V2.8Z'
      fill='#333'
    />
  </svg>
);

export default SvgFilter;
